import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { HbaseLinkedService, hbaseAuthTypes } from 'app/model/linkedservice/hbase.linkedservice';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(HbaseLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                host: '*',
                port: '*',
                httpPath: '*',
                authenticationType: '*',
                username: '*',
                password: 'secret',
                enableSsl: '*',
                trustedCertPath: '*',
                allowHostNameCNMismatch: '*',
                allowSelfSignedServerCert: '*',
                encryptedCredential: '*'
            }
        }
    }
})
export class HbaseLinkedServiceAdapter extends LinkedServiceAdapter<HbaseLinkedService> {
    protected modelConstructor(): new () => HbaseLinkedService {
        return HbaseLinkedService;
    }

    protected model(): IModel {
        return HbaseLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: HbaseLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.HBaseLinkedService;
        properties.type = Metamodel.modelFor(HbaseLinkedService).name;
        const password: Model.SecretBase = linkedService.authenticationType === hbaseAuthTypes.Basic && linkedService.password ?
            passwordOrAKVtoSecretBase(linkedService.password, this.context) : undefined;
        properties.typeProperties = {
            host: linkedService.host,
            port: linkedService.port,
            httpPath: linkedService.httpPath,
            authenticationType: linkedService.authenticationType,
            username: linkedService.authenticationType !== hbaseAuthTypes.Anonymous ? linkedService.username : undefined,
            password,
            enableSsl: linkedService.enableSsl,
            trustedCertPath: linkedService.enableSsl ? linkedService.trustedCertPath : undefined,
            allowHostNameCNMismatch: linkedService.enableSsl ? linkedService.allowHostNameCNMismatch : undefined,
            allowSelfSignedServerCert: linkedService.enableSsl ? linkedService.allowSelfSignedServerCert : undefined
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: HbaseLinkedService): Promise<HbaseLinkedService> {
        const properties = linkedServiceResource.properties as Model.HBaseLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.HBaseLinkedServiceTypeProperties = properties.typeProperties;

        linkedService.host = typeProperties.host;
        linkedService.port = typeProperties.port;
        linkedService.httpPath = typeProperties.httpPath;
        linkedService.authenticationType = typeProperties.authenticationType;
        linkedService.username = typeProperties.username;
        linkedService.password = secretBaseToPasswordOrAKV(typeProperties.password, typeProperties.authenticationType === hbaseAuthTypes.Basic, this.context);
        linkedService.enableSsl = typeProperties.enableSsl;
        linkedService.trustedCertPath = typeProperties.trustedCertPath;
        linkedService.allowHostNameCNMismatch = typeProperties.allowHostNameCNMismatch;
        linkedService.allowSelfSignedServerCert = typeProperties.allowSelfSignedServerCert;

        return linkedService;
    }
}
